<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">充值卡</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/"><van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/></router-link>
            </template>
        </van-nav-bar>

        <van-tabs v-model="tabActive" @click="onLoad(true)">
            <van-tab title="未使用" name="0"></van-tab>
            <van-tab title="已使用" name="1"></van-tab>
        </van-tabs>

        <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                :error-text="error_text"
                finished-text="没有更多了"
                @load="onLoad(false)"
        >
            <van-collapse v-model="listActive">


                <van-row v-for="item in list" :key="item.id" >

                    <van-cell>
                        <template #title>
                            {{item.number}}
                        </template>
                        <template #label>
                            {{undefined === item.product?'':item.product.title}},{{item.created_at}}
                        </template>
                        <template #right-icon>
                            <van-button size="small" @click="toCopy(item)">复制</van-button>
                        </template>
                    </van-cell>

                </van-row>

            </van-collapse>
        </van-list>



    </div>
</template>

<script>
    import copy from 'copy-to-clipboard';
    export default {
        data() {
            return {
                tabActive:0,
                page:1,
                listActive:[],

                loading:false,
                finished:false,
                error:false,
                error_text: "",
                searchValue: "",

                list:[]
            };
        },
        created() {

        },
        methods:{
            onLoad(isNew){
                if (isNew){
                    this.list=[];
                    this.page=1;
                    this.finished=false;
                }
                this.loading = true;
                this.$http.get("/wechat/cd_keys", {
                    params: {
                        pre_page:15,
                        page:this.page,
                        status: this.tabActive
                    }
                }).then(res => {
                    this.loading = false;
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.error = true
                        this.error_text = res.data.msg
                        return
                    }
                    if (!res.data.data || res.data.data.length <= 0) {
                        this.finished = true
                        return;
                    }
                    this.page++

                    this.list = this.list.concat(res.data.data);
                });
            },
            toCopy(item){
              copy(item.number)
                this.$toast.success("复制成功")
            },
            getLearnTypeText(learn_type){
                if (1 == learn_type){
                    return "模拟练习"
                }else {
                    return "课程学习"
                }

            }
        }
    }
</script>
